"use strict";

exports.__esModule = true;
var _EventTimelineController = require("./EventTimelineController");
Object.keys(_EventTimelineController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EventTimelineController[key]) return;
  exports[key] = _EventTimelineController[key];
});